import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();
export const overviewRouteRef = createRouteRef();
export const recordingsRouteRef = createRouteRef();
export const statisticsRouteRef = createRouteRef();
